var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"btn-voltar"}},[_c('button',{staticClass:"btn btn-default btn-block",attrs:{"type":"button"},on:{"click":_vm.voltar}},[_c('i',{staticClass:"fa fa-arrow-circle-left",attrs:{"aria-hidden":"true"}}),_vm._v("\n      Voltar\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }